const NoiseOverlay = () => (
  <>
    <div className="noise-overlay" />
    <div className="vignette" />
    <div className="scanlines" />
  </>
);

export default NoiseOverlay;
